export const STAGES = [
  { key: 'pick_list', label: 'Pick List', kind: 'picking' },
  { key: 'bom_confirm', label: 'BOM Confirmation', kind: 'upload_approve' },
  { key: 'cutting_list', label: 'Cutting List', kind: 'upload_approve' },
  { key: 'cnc_cutting', label: 'CNC Cutting', kind: 'choice', options: [{ value: 'double_end', label: 'Double-End CNC Cutter' }, { value: 'single_head', label: 'Single-Head CNC Cutter' }] },
  { key: 'end_miller', label: 'CNC End Miller', kind: 'simple' },
  { key: 'copy_router', label: 'Copy Router', kind: 'choice', options: [{ value: 'normal', label: 'Normal Copy Router' }, { value: 'cnc_2axis', label: 'CNC Two-Axis Copy Router' }] },
  { key: 'drill_punch', label: 'Drilling & Punching', kind: 'simple' },
  { key: 'assembly', label: 'Assembly', kind: 'simple' },
  { key: 'glazing', label: 'Glazing', kind: 'choice', options: [{ value: 'factory', label: 'Glazing at Factory' }, { value: 'site', label: 'Glazing at Site' }] },
  { key: 'qc', label: 'Quality Control', kind: 'simple' },
];

export const optionLabel = (stageKey, value) => {
  const s = STAGES.find((x) => x.key === stageKey);
  if (!s || !s.options) return value;
  const o = s.options.find((x) => x.value === value);
  return o ? o.label : value;
};

// Next upcoming Wednesday (3) or Saturday (6), never today
export const nextDispatchDate = (day) => {
  const target = day === 'wednesday' ? 3 : 6;
  const d = new Date();
  let diff = (target - d.getDay() + 7) % 7;
  if (diff === 0) diff = 7;
  d.setDate(d.getDate() + diff);
  return d.toISOString().slice(0, 10);
};

export const fmtDateTime = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
};

// Human duration from milliseconds
export const fmtDuration = (ms) => {
  if (ms == null || ms < 0) return '—';
  const mins = Math.floor(ms / 60000);
  if (mins < 1) return '<1m';
  const d = Math.floor(mins / 1440);
  const h = Math.floor((mins % 1440) / 60);
  const m = mins % 60;
  const parts = [];
  if (d) parts.push(`${d}d`);
  if (h) parts.push(`${h}h`);
  if (m && !d) parts.push(`${m}m`);
  return parts.join(' ') || '<1m';
};

// Duration a stage took (or elapsed so far if still running); returns ms or null
export const stageDurationMs = (stage) => {
  if (!stage || !stage.started_at) return null;
  const start = new Date(stage.started_at).getTime();
  const end = stage.completed_at ? new Date(stage.completed_at).getTime() : Date.now();
  return end - start;
};
